import React from 'react';
import PlaysEvents from '../PlaysEvents/PlaysEvents';

const MobileHeaderEvents = ({ cl }) => (
  <div className={cl.mobileHeaderEvents}>
    <PlaysEvents />
  </div>
);
export default MobileHeaderEvents;
